<template>
    <div>
        <div class="sideMenu-title mb-2">
            기본설정
        </div>
        <div class="sideMenu">
            <!--<ul style="width:100%;" class="default-Btn-1 my-12 hidden-sm-and-down">-->
            <div class="sideMenu-group">
                <ul style="width:100%;" class="">
                    <li class="">
                        <a :class="{active : menuActive.isActive0}" @click="menuClick('/admin/main')">기본정보</a>
                    </li>
                    <li class="">
                        <a :class="{active : menuActive.isActive1}" @click="menuClick('/admin/payInfo')">결제/계좌정보</a>
                    </li>
                    <li class="">
                        <a :class="{active : menuActive.isActive2}" @click="menuClick('/admin/smsInfo')">SMS설정</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'AdminMainMenu',
        data: () => ({
            menuActive: {
                isActive0: false,
                isActive1: false,
                isActive2: false,
                isActive3: false,
                isActive4: false,
                isActive5: false,
                isActive6: false,
            }
        }),
        created: function () {
            this.setMenuActive();
        },
        computed: {

        },
        methods: {
            menuClick(route) {

                location.href = route;
            },
            setMenuActive(){
                switch (window.location.pathname) {
                    case "/admin/main":{
                        this.menuActive.isActive0 = true;
                        break;
                    }
                    case "/admin/payInfo":{
                        this.menuActive.isActive1 = true;
                        break;
                    }
                    case "/admin/smsInfo":{
                        this.menuActive.isActive2 = true;
                        break;
                    }
                }

            }
        },


    }

</script>

<style lang="scss" scoped>
    /*@import './base.scss';*/


</style>
